<template>
  <MainLayout>
    <div id="case-container" class="flex flex-col gap-y-16 lg:gap-y-30 max-w-full lg:max-w-[1200px] mx-auto mt-2">
      <div class="parallax"
           data-parallax
           data-parallax-speed="0.25"
           data-parallax-direction="down">
        <div class="relative w-screen ">
          <img class="absolute -left-[1vw] top-[-12vh] w-[20vw] opacity-80"
               src="/images/bg-visual-left-top.webp"
               alt="">
          <img class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60"
               src="/images/bg-visual-right-top.webp"
               alt="">
        </div>
      </div>

      <section id="hero" class="flex !items-start max-w-[1080px] max-md:-mt-10 lg:m-[auto] !gap-y-2">
        <img class="h-16 w-16 rounded-lg" src="/images/cases/lunchroom/logo-two-b.webp" alt="">
        <div class="flex max-md:flex-col justify-between gap-x-16 max-md:gap-y-10">
          <div class="flex flex-col gap-y-8">
            <h1 class="text-3xl lg:text-[44px] lg:leading-[50px] font-bold text-dark font-markPro tracking-[-0.08rem] pt-8">
              {{ t('pages.cases.lunchroom.hero.title') }}
            </h1>

            <p class="text-lighter max-w-[570px]">{{ t('pages.cases.lunchroom.hero.description') }}</p>
          </div>

          <img class="rounded-[25px] max-md:mx-5" src="/images/cases/lunchroom/img-header-two-b.webp" alt="">
        </div>
      </section>

      <section id="testimonial">
        <div class="bg-[#E3EEF7] flex flex-col lg:flex-row justify-between items-center px-8 lg:px-16 py-8 lg:py-14 gap-10 lg:gap-20 rounded-2xl">
          <img class="rounded-full w-34 h-34 lg:h-48 lg:w-48"
               src="/images/cases/lunchroom/img-two-b-mondie-big.webp"
               alt="">

          <div class="flex flex-col justify-between gap-8 max-md:text-center">
            <p class="text-2xl lg:text-[26px] lg:leading-[36px] font-semibold font-markPro tracking-[-0.03rem]">
              {{ t('pages.cases.lunchroom.testimonials.1.text') }}
            </p>

            <p class="text-lg lg:text-[20px]">
              <span class="font-semibold">{{ t('pages.cases.lunchroom.testimonials.1.name') }}, </span>
              <span class="text-lighter">{{ t('pages.cases.lunchroom.testimonials.1.job_title') }}</span>
            </p>
          </div>
        </div>
      </section>

      <section id="challenge" class="max-w-[1080px] lg:m-[auto]">
        <div class="flex max-md:flex-col max-md:flex-col-reverse gap-x-20 gap-y-5 lg:mt-[-2rem]">
          <img src="/images/img-mock-1.webp" class="h-full lg:max-w-[600px]">

          <div class="flex flex-col gap-y-8 h-full pt-10">
            <h4 class="font-markPro text-2xl lg:text-[40px] font-bold">
              {{ t('pages.cases.lunchroom.challenge.paragraph.title') }}</h4>

            <p class="text-lighter">{{ t('pages.cases.lunchroom.challenge.paragraph.text') }}</p>
          </div>
        </div>

        <div class="flex max-md:flex-col max-md:flex-col-reverse gap-x-30 gap-y-10 lg:even:flex-row-reverse">
          <img src="/images/cases/lunchroom/img-two-b-2.webp" class="h-full lg:max-w-[600px] max-md:mx-5">

          <div class="flex flex-col gap-y-8 h-full">
            <h4 class="font-markPro text-2xl lg:text-[40px] font-bold">
              {{ t('pages.cases.lunchroom.challenge.paragraph_2.title') }}</h4>

            <ul class="text-lighter list-disc list-inside flex flex-col gap-y-2">
              <li>{{ t('pages.cases.lunchroom.challenge.paragraph_2.bullets.1') }}</li>
              <li>{{ t('pages.cases.lunchroom.challenge.paragraph_2.bullets.2') }}</li>
              <li>{{ t('pages.cases.lunchroom.challenge.paragraph_2.bullets.3') }}</li>
              <li>{{ t('pages.cases.lunchroom.challenge.paragraph_2.bullets.4') }}</li>
            </ul>
          </div>

        </div>

      </section>

      <section id="testimonial-two">
        <div class="bg-[#E3EEF7] flex flex-col lg:flex-row-reverse justify-between items-center px-8 lg:px-16 py-8 lg:py-14 gap-10 lg:gap-20 rounded-2xl">
          <img class="rounded-full w-34 h-34 lg:h-48 lg:w-48"
               src="/images/cases/lunchroom/img-two-b-mondie-big.webp"
               alt="">

          <div class="flex flex-col justify-between gap-8 max-md:text-center">
            <p class="text-2xl lg:text-[26px] lg:leading-[36px] font-semibold font-markPro tracking-[-0.03rem]">
              {{ t('pages.cases.lunchroom.testimonials.2.text') }}
            </p>

            <p class="text-lg lg:text-[20px]">
              <span class="font-semibold">{{ t('pages.cases.lunchroom.testimonials.2.name') }}, </span>
              <span class="text-lighter">{{ t('pages.cases.lunchroom.testimonials.2.job_title') }}</span>
            </p>
          </div>
        </div>
      </section>

      <section id="solution" class="max-w-[1080px] lg:m-[auto]">
        <div class="flex max-md:flex-col max-md:flex-col-reverse gap-x-20 gap-y-10">
          <img src="/images/img-mock-1.webp" class="h-full lg:max-w-[600px]">

          <div class="flex flex-col gap-y-8 h-full">
            <h4 class="font-markPro text-2xl lg:text-[40px] font-bold">{{
                t('pages.cases.lunchroom.solution.title')
              }}</h4>

            <div class="flex flex-col gap-y-4">
              <div class="flex gap-x-2">
                <img src="/images/ico-check.svg" class="h-[28px]"/>
                <p class="text-lighter">{{ t('pages.cases.lunchroom.solution.checklist.1') }}</p>
              </div>

              <div class="flex gap-x-2">
                <img src="/images/ico-check.svg" class="h-[28px]"/>
                <p class="text-lighter">{{ t('pages.cases.lunchroom.solution.checklist.2') }}</p>
              </div>

              <div class="flex gap-x-2">
                <img src="/images/ico-check.svg" class="h-[28px]"/>
                <p class="text-lighter">{{ t('pages.cases.lunchroom.solution.checklist.3') }}</p>
              </div>

              <div class="flex gap-x-2">
                <img src="/images/ico-check.svg" class="h-[28px]"/>
                <p class="text-lighter">{{ t('pages.cases.lunchroom.solution.checklist.4') }}</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section id="conclusion" class="max-w-[1080px] max-md:mb-5 lg:m-[auto]">
        <div class="flex flex-col gap-y-8 h-full">
          <h4 class="font-markPro text-2xl lg:text-[40px] font-bold">{{
              t('pages.cases.lunchroom.conclusion.title')
            }}</h4>

          <p class="text-lighter">{{ t('pages.cases.lunchroom.conclusion.text.1') }}</p>

          <p class="text-lighter">{{ t('pages.cases.lunchroom.conclusion.text.2') }}</p>
        </div>
      </section>

      <section id="cta" class="backgroundgradient backgroundgradient-bottom">
        <div class="w-full rounded-2xl py-16 max-md:px-14 lg:pt-26 lg:pb-20 relative overflow-hidden">

          <div class="absolute inset-0 z-10 bg-[#E3EEF7]"></div>
          <div class="parallax "
               data-parallax
               data-parallax-speed="0.05"
               data-parallax-direction="down">

            <div class="relative w-full h-full">
              <img class="absolute top-0 left-0 -translate-x-1/3 h-[150%] rotate-[45%]"
                   src="/images/bg-visual-left-top.webp"
                   alt="">

              <img class="absolute right-0 translate-x-1/3 -top-1/4 lg:-top-1/2 h-1/2 lg:h-full rotate-[-20deg]"
                   src="/images/bg-visual-right-top.webp"
                   alt="">
            </div>
          </div>

          <div class="flex flex-col gap-y-5.5 justify-center items-center text-center relative z-30">
            <h4 class="text-[32px] leading-[42px] lg:text-5xl font-bold text-dark text-center font-markPro block tracking-[-0.08rem]">
              {{ t('main.cta_block.open_your_webshop_today') }}
              <span class="text-gradient-primary whitespace-nowrap">
                {{ t('main.cta_block.its_free') }}
              </span>
            </h4>

            <p class="text-lg lg:text-[24px] text-lighter font-semibold">
              {{ t('main.cta_block.start_generating_more_orders') }}
            </p>

            <a v-track-event="'onboarding_start'"
               href="https://merchant.bistroo.nl/register"
               class="btn btn-lg btn-primary flex items-center gap-x-3 mt-4">
              <span>
                {{ t('main.cta_block.get_started_for_free') }}
              </span>
              <i class="bi bi-arrow-right text-lg mt-[3px]"></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">

import MainLayout from '@/layouts/MainLayout.vue'
import { useI18n } from 'vue-i18n'

const {t, tm, rt} = useI18n()
</script>

<style scoped>

</style>